import { Nullable, SelectOption } from '$models'
import { Dayjs } from 'dayjs'
import {
  Variation,
  transformVariationOnGet,
  transformVariationOnSave,
} from '$models'
import { ManagedOrCustomType } from '$constants'
import { transformNumberProperty } from '$utils'

export interface PayClassification {
  id?: string
  name?: string
  description?: Nullable<string>
  baseHourlyRate: number | string
  isActive: boolean
  type: ManagedOrCustomType
  variations: Variation[]
  datestampDeleted?: Nullable<Dayjs>
}

// Function to apply transformations to PayClassification object
export const transformPayClassificationOnSave = (
  payClassification: PayClassification
): PayClassification => {
  return {
    ...payClassification,
    baseHourlyRate: transformNumberProperty(
      `${payClassification.baseHourlyRate}`
    ),
    variations: payClassification.variations.map(transformVariationOnSave),
  }
}

// Function to apply transformations to PayClassification object
export const transformPayClassificationOnGet = (
  payClassification: PayClassification
): PayClassification => {
  return {
    ...payClassification,
    variations: payClassification.variations.map(transformVariationOnGet),
  }
}

export const newPayClassification: PayClassification = {
  baseHourlyRate: 0,
  isActive: true,
  type: ManagedOrCustomType.Custom,
  variations: [],
}

export const getPayClassificationsAsOptions = (
  payClassifications: PayClassification[]
): SelectOption[] =>
  payClassifications.map((payClassification) => {
    return {
      label: payClassification.name!,
      value: payClassification.id!,
    }
  })
